export const DataState = {
  Unchanged: "Unchanged",
  Changed: "Changed",
  New: "New",
  Remove: "Remove",
} as const;

export type DataState = (typeof DataState)[keyof typeof DataState];
